import { Tag } from 'antd';
import { FC, memo } from 'react';

import { DomainWWWRedirect } from '../../domains.interfaces';

interface Props {
  redirect: DomainWWWRedirect;
}

export const DomainsWWWRedirectTag: FC<Props> = memo(({ redirect }) => {
  if (redirect === DomainWWWRedirect.None) {
    return <Tag>Немає</Tag>;
  }

  if (redirect === DomainWWWRedirect.WWWToWithoutWWW) {
    return (
      <Tag>
        З&nbsp;<strong>WWW</strong>&nbsp;на&nbsp;<strong>без&nbsp;WWW</strong>
      </Tag>
    );
  }

  if (redirect === DomainWWWRedirect.WithoutWWWToWWW) {
    return (
      <Tag>
        <strong>Без&nbsp;WWW</strong>&nbsp;на&nbsp;<strong>WWW</strong>
      </Tag>
    );
  }

  return <Tag></Tag>;
});
